export default {
    'OPERACION_TIPO': (state, mutation) => {
        state.tipoFianza = mutation.tipoFianza
    }
}